<template>
  <div>
    <div class="vjs-menu-title">{{ $t('modals.quality') }}</div>
    <div class="QualitySection my-10">
      <button v-for="(level, index) in qualityLevels" :key="index" class="QualityBtn card_btn"
        :class="{ active: index == activeRate }" v-on:click="changeRate(index)">
        <span class="quality">{{ level?.height }}p</span>
      </button>
      <button class="QualityBtn card_btn" :class="{ active: activeRate == -1 }" v-on:click="changeRate(-1)">
        <span class="quality">AUTO</span>
      </button>
    </div>
  </div>
</template>

<script >
import { defineComponent } from "vue";
import en from '../../../../../i18n/en_US'
import fr from '../../../../../i18n/fr_FR'

export default defineComponent({
  name: "RateSection",
  i18n: {
    messages: {
      en: en,
      fr: fr,
    },
  },
  components: {},
  props: {
    player: {
      type: Object,
    },
    currentQualityIndex: {
      type: Function,
    },
    closeModal: {
      type: Function,
    },
  },
  data() {
    return {
      qualityLevels: [],
      activeRate: -1,
    };
  },
  mounted() {
    this.qualityLevels = this.player?.qualityLevels().levels_;
    this.activeRate = this.currentQualityIndex?.();
  },
  methods: {
    changeRate(i) {
      this.activeRate = i;
      this.currentQualityIndex?.(i);
      if (i > -1) {
        this.player?.hlsQualitySelector.setQuality(
          this.qualityLevels[i]?.height
        );
      } else {
        this.player?.hlsQualitySelector.setQuality("auto");
      }
      this.closeModal?.();
    },
  },
});
</script>
<style>
.QualitySection {
  display: flex;
  justify-content: space-around;
  margin: 5px 0px 10px 0px;
  flex-wrap: wrap;
}

.QualitySection .QualityBtn {
  cursor: pointer;
  position: relative;
  width: auto;
  display: inline-block;
  padding: 0.25em;
  margin: 0 0.2em 0.5em 0;
  border-radius: 0.3em;
  border: 2px solid transparent;
  background: transparent;
  color: var(--vm-color-three);
}

.QualitySection .QualityBtn.active {
  border: 2px solid var(--vm-color-two-08);
  font-weight: 600;
}

.QualitySection .QualityBtn:hover {
  background-color: var(--vm-color-two-08) !important;
  color: var(--vm-color-three-08) !important;
}

.QualitySection .QualityBtn.tagged {
  padding-right: 30px !important;
}

.QualitySection .QualityBtn .taggedQuality {
  position: absolute;
  font-size: 8px;
  z-index: 5;
  top: 0px;
  right: 1px;
  font-weight: 900;
}

@media screen and (max-width: 576px) {
  .QualitySection {
    display: flex;
    justify-content: space-around;
  }

  .QualitySection .QualityBtn {
    margin: 0 0px;
    cursor: pointer;
    position: relative;
  }

  .QualitySection .QualityBtn .quality {
    font-size: 3vw;
    top: 6px;
    right: 7px;
  }

  .QualitySection .QualityBtn.active {
    border: 1px solid var(--vm-color-one-08);
  }
}
</style>
